import styles from './index.scss'
import { Form, Input, Button, Popup, Space, Checkbox, Toast } from 'antd-mobile'
import React, { useRef, useState, useEffect } from 'react'
import {
  captchaImage,
  memberSendSms,
  login,
  memberInfo,
  loginBind,
} from '@/services/index'
import { getUrlAllParams, getUrlParam } from '@/libs/functions/getValue'
import { setStorage, getStorage } from '@/libs/functions/onStorage'
import goTo from '@/libs/functions/goTo'
import Layout from '@/libs/components/Layout'
import useCategorySet from '@/libs/hooks/useCategorySet'
import {
  generateButtonStyle,
  generateCertificateStyleVars,
} from '@/libs/functions/generateCssVars'
import { getMiniProgramChannelApi } from '@/libs/functions/appAdapter'

import ThirdCodeModal from '../components/ThirdCodeModal'
import useLang from '@/libs/hooks/useLang'
import { DpPhoneNumber } from '@/libs/components'

import { EXCHANGE_CODE_NEED_BACK } from '@/libs/constant/index'
import { TrackLogin } from '@/libs/functions/dpTrack'

let timer: any = null

export default function Login(props: any) {
  const { t } = useLang('prompt_util')
  const channel = getStorage('channel')
  const channelApi = getMiniProgramChannelApi(channel)
  const urlParams = getUrlAllParams() as any
  const redirect = getUrlParam('redirect')
  const tenantCode = getUrlParam('tenantCode') || ''
  // const { tenantCode } = urlParams
  const [termsModal, setTermsModal] = useState(false)
  const [loading, setLoading] = useState(false)
  const [checkClause, setCheckClause] = useState(false)
  const [ticket, setTicket] = useState('') // 图像验证码票据
  const [imageBase64, setImageBase64] = useState('') // 图片验证码base64
  const [time, setTime] = useState(0)
  const [pageLoading, setPageLoading] = useState(true)
  const [showThirdCodeModal, setShowThirdCodeModal] = useState(false) // 登录成功后校验弹窗
  const [validateKey, setValidateKey] = useState('') // 用于登录成功后校验接口

  const [form] = Form.useForm()
  const { categorySetting } = useCategorySet('LOGIN', tenantCode)
  const { certificatePage, buttonStyle, h5Setting = {} } = categorySetting
  const customTextStyle = generateCertificateStyleVars(certificatePage)
  const customButtonStyle = generateButtonStyle(buttonStyle)
  const {
    pageTitle,
    privacy = true,
    banner = [],
    pageBackground,
    bgColor,
    backgroundImage,
    terms,
    termsLabelText, // 用户隐私条款标题
    userAuthText, // 用户授权文案
    openLoginPage,
  } = certificatePage || {}
  // console.log(openLoginPage)
  const { userName: isShowUserName = false, openSucceedVerify } =
    h5Setting || {}

  const pageBackgroundStyle =
    pageBackground === 'color'
      ? bgColor
      : `url(${backgroundImage}) no-repeat center top  / 100% auto`

  useEffect(() => {
    setPageLoading(true)
    if (channelApi && channelApi.goToLogin) {
      channelApi.goToLogin({ redirectUrl: redirect })
      return
    }
    getCaptchaImage().finally(() => {
      setPageLoading(false)
    })
  }, [])

  const getCaptchaImage = async () => {
    const { ticket, base64 } = (await captchaImage()) as any
    setTicket(ticket)
    setImageBase64(base64)
  }

  const getMemberSendSms = async () => {
    if (time > 0) return
    const { capCode, mobile } = await form.validateFields(['capCode', 'mobile'])
    const { mobile: pureMobile, countryCallPrefix } = parsePhone(mobile)
    await memberSendSms({
      ticket,
      capCode,
      mobile: pureMobile,
      tenantCode,
      countryCallPrefix,
    })

    setTime(60)
  }

  useEffect(() => {
    timer && clearInterval(timer)
    return () => timer && clearInterval(timer)
  }, [])

  useEffect(() => {
    if (time === 60) timer = setInterval(() => setTime((time) => --time), 1000)
    else if (time === 0) clearInterval(timer)
  }, [time])

  const svgFill: any = customTextStyle['--adm-color-primary']

  const parsePhone = (value?: string) => {
    if (!value) {
      return { mobile: '', countryCallPrefix: '' }
    }
    const parts = String(value).split('-')
    if (parts.length > 1) {
      return {
        countryCallPrefix: parts[0] || '+86',
        mobile: parts.slice(1).join('-'),
      }
    }
    return {
      countryCallPrefix: '+86',
      mobile: String(value),
    }
  }

  const onLoginAfter = ({
    token,
    route,
    isThirdVerifyUrl,
    nickName,
    guestCode,
    memberCode,
  }: Record<string, any>) => {
    setStorage('h5Token', token)
    setStorage('tenantCode', tenantCode)
    setStorage('memberCode', memberCode)
    setStorage('guestCode', guestCode)
    // isThirdVerifyUrl: 是否是ka
    if (isThirdVerifyUrl && route) {
      goTo(decodeURIComponent(route), {
        type: 'replace',
      })
      return
    }
    // 未登录
    if (redirect) {
      // 无须解码，getUrlParam 已经转了，直接跳转即可
      goTo(redirect, {
        type: 'replace',
      })
      return
    }

    if (!isThirdVerifyUrl && route) {
      goTo(decodeURIComponent(route), {
        type: 'replace',
      })
      return
    }
    memberInfo().then((res: any) => {
      if (res.levelId) {
        goTo('/memberEquity/levelZone', { type: 'replace' })
      } else {
        goTo('/personal', { type: 'replace' })
      }
    })
  }

  const onFinish = async (values) => {
    const { smsCode, mobile, userName = '', capCode } = values
    const { mobile: pureMobile, countryCallPrefix } = parsePhone(mobile)
    if (isShowUserName && !userName) {
      Toast.show({ content: t('realNamePlaceholder', '请输入真实姓名') })
      return
    }
    if (
      !pureMobile ||
      (countryCallPrefix === '+86' &&
        !new RegExp('^[1][2-9][0-9]{9}$').test(pureMobile))
    ) {
      Toast.show({
        content: t('mobileRuleMessage', '请输入正确的手机号码'),
      })
      return
    }
    if (!capCode) {
      Toast.show({ content: t('capCodePlaceholder', '请输入图片验证码') })
      return
    }
    if (!smsCode) {
      Toast.show({ content: t('smsCodePlaceolder', '请输入手机验证码') })
      return
    }
    const { navigator } = window as any
    setLoading(true)
    login({
      smsCode,
      mobile: pureMobile,
      userName: userName ? userName?.trim() : '',
      tenantCode,
      ip: '',
      userAgent: navigator.userAgent,
      urlParams,
      countryCallPrefix,
      ticket,
      capCode,
    })
      .then((res: any) => {
        const {
          isNeedValidateCode,
          validateKey,
          memberCode,
          guestCode = '',
        } = res
        if (isNeedValidateCode) {
          setValidateKey(validateKey)
          setShowThirdCodeModal(true)
          return
        }
        onLoginAfter(res)
        try {
          TrackLogin({ user_id: memberCode }, { guest_code: guestCode })
        } catch (err) {}
      })
      .finally(() => setLoading(false))
  }

  const onLoginBind = async (values) => {
    loginBind({
      validateKey,
      tenantCode,
      ...values,
    }).then((res) => {
      onLoginAfter(res)
    })
  }

  return openLoginPage === false ? (
    <div className={styles.noLoginPage}>
      {t('pageNotFound', '此页面不存在')}
    </div>
  ) : !pageLoading ? (
    <Layout
      title={pageTitle}
      style={{ background: pageBackground === 'color' ? bgColor : '#fff' }}
      navBarStyle={{ background: 'none' }}
    >
      <div
        className={styles.loginPage}
        style={{
          background: pageBackgroundStyle,
          ...customButtonStyle,
          ...customTextStyle,
        }}
      >
        <div className={styles.wrap}>
          <img
            src={
              banner?.length > 0
                ? banner[0]
                : require('@/assets/image/logo.png')
            }
            className={styles.logo}
          />
          <div className={styles.container}>
            <Form
              form={form}
              className={styles.loginForm}
              layout="horizontal"
              onFinish={onFinish}
              footer={
                <Button
                  className={styles.footerBtn}
                  style={{
                    ...customButtonStyle,
                    ...customTextStyle,
                  }}
                  disabled={privacy ? !checkClause : false}
                  block
                  shape="rounded"
                  loading={loading}
                  type="submit"
                  color="primary"
                >
                  {t('loginBtnText', '登 录')}
                </Button>
              }
            >
              {isShowUserName && (
                <Form.Item className={styles['form-item']} name="userName">
                  <Input
                    type="text"
                    clearable
                    placeholder={t('realNamePlaceholder', '请输入真实姓名')}
                  />
                </Form.Item>
              )}
              <Form.Item className={styles['form-item']} name="mobile">
                <DpPhoneNumber
                  beforeProps={{
                    url: '/api/business/member/getPhonePreList',
                  }}
                  configType="‌i18n‌Config"
                  placeholder={t('mobilePlaceholder', '请输入手机号')}
                />
              </Form.Item>
              <Form.Item
                className={styles['form-item']}
                name="capCode"
                extra={
                  <img
                    onClick={getCaptchaImage}
                    className={styles.captchaImage}
                    src={imageBase64}
                  />
                }
              >
                <Input
                  placeholder={t('capCodePlaceholder', '请输入图片验证码')}
                  clearable
                  maxLength={4}
                />
              </Form.Item>
              <Form.Item
                className={styles['form-item']}
                name="smsCode"
                extra={
                  <div className={styles.getCode} onClick={getMemberSendSms}>
                    {time === 0 ? t('getSmsCode', '获取验证码') : `（${time}）`}
                  </div>
                }
              >
                <Input
                  type="number"
                  placeholder={t('smsCodePlaceolder', '请输入手机验证码')}
                  clearable
                  onChange={(value) => {
                    form.setFieldsValue({
                      smsCode: value.slice(0, 4),
                    })
                  }}
                />
              </Form.Item>
              {privacy && (
                <Checkbox
                  className={styles.clauseWrap}
                  style={{ '--icon-size': '14px', '--font-size': '12px' }}
                  checked={checkClause}
                  onChange={(e) => setCheckClause(e)}
                >
                  <span
                    className={styles.clause}
                    onClick={() => {
                      setTermsModal(true)
                    }}
                  >
                    {termsLabelText}
                  </span>
                </Checkbox>
              )}
            </Form>
            {userAuthText && (
              <div className={styles.userAuthText}>{userAuthText}</div>
            )}
          </div>
        </div>
      </div>
      <Popup
        showCloseButton
        visible={termsModal}
        onMaskClick={() => {
          setTermsModal(false)
        }}
        onClose={() => {
          setTermsModal(false)
        }}
        position="right"
        bodyStyle={{ width: '100vw' }}
      >
        <div className={styles.termsContentWrap}>
          <p
            className={styles.termsModalContent}
            dangerouslySetInnerHTML={{ __html: terms }}
          ></p>
        </div>
      </Popup>
      <ThirdCodeModal
        h5Setting={h5Setting}
        customStyle={{
          ...customButtonStyle,
          ...customTextStyle,
        }}
        visible={showThirdCodeModal}
        onClose={() => {
          setShowThirdCodeModal(false)
        }}
        onOk={onLoginBind}
      />
    </Layout>
  ) : (
    <></>
  )
}
